import Button from "../../../core/Button";
import { Loader2 } from "lucide-react";
import { Skeleton } from "../../../shadcn/Skeleton";
import { Card, CardContent, CardTitle, CardHeader } from "../../../shadcn/Card";
import { SearchErrorContent } from "./SearchErrorMessage";

export function PropertySearchSkeleton() {
  return (
    <>
      <CardHeader className="py-3">
        <CardTitle className="text-center text-xl text-primary relative">
          <Skeleton className="h-7 w-32 mx-auto" />
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col items-center gap-3">
        <div className="flex flex-row items-center gap-3 w-full">
          <Skeleton className="h-10 flex-1 rounded-md" />
          <Skeleton className="h-10 w-24 rounded-md" />
        </div>
        <Skeleton className="h-10 w-16 rounded-md" />
      </CardContent>
    </>
  );
}

export interface SearchResultsCardProps {
  children?: React.ReactNode;
  isFetching?: boolean;
  showSkeleton?: boolean;
}

export function SearchResultsCard({ children, isFetching = false, showSkeleton = false }: SearchResultsCardProps) {
  if (showSkeleton) {
    return (
      <div className="flex flex-col gap-3 w-full items-center">
        <Card className="w-full min-h-[158px] border-orange-500">
          <PropertySearchSkeleton />
        </Card>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3 w-full items-center">
      <Card className="w-full min-h-[158px] border-orange-500">
        {children}
      </Card>
    </div>
  );
}

export interface ClearSearchButtonProps {
  onClearSearchClick: () => void;
}

export function ClearSearchButton({ onClearSearchClick }: ClearSearchButtonProps) {
  return (
    <Button onClick={onClearSearchClick} variant="secondary">
      Cancel
    </Button>
  );
}

export interface ErrorResultsProps {
  error?: Error | null;
  isFetching?: boolean;
  onClearSearchClick: () => void;
}

export function ErrorResults({ error, isFetching, onClearSearchClick }: ErrorResultsProps) {
  return (
    <SearchErrorContent
      error={error}
      isFetching={isFetching}
      clearSearchButton={<ClearSearchButton onClearSearchClick={onClearSearchClick} />}
    />
  );
}

export interface NoMatchingResultsProps {
  title: string;
  message: string;
  isFetching?: boolean;
  onClearSearchClick: () => void;
}

export function NoMatchingResults({ title, message, isFetching, onClearSearchClick }: NoMatchingResultsProps) {
  return (
    <CardHeader className="py-3">
      <CardTitle className="text-center text-xl text-secondary-foreground relative">
        {title}
        {isFetching && (
          <Loader2 className="absolute right-0 top-0 animate-spin h-5 w-5" />
        )}
      </CardTitle>
      <CardContent className="flex text-sm text-center flex-col items-center gap-3">
        {message}
        <ClearSearchButton onClearSearchClick={onClearSearchClick} />
      </CardContent>
    </CardHeader>
  );
}